import { render } from "./noticeDetail.vue?vue&type=template&id=5ced3f7c&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"

import "./noticeDetail.vue?vue&type=style&index=0&id=5ced3f7c&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ced3f7c"]])

export default __exports__